export default __webpack_public_path__ + "static/media/offline.33adaea5.svg";